import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { useClientUser } from '@src/clientUser/useClientUser';
import { SideNav, SideNavLink } from '@src/common/SideNav';
import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import { Navigation } from '@src/routing/Navigation';
import { useTranslation } from 'react-i18next';

export const ClientUsersSideNav = () => {
  const { t } = useTranslation();
  const iconSize = 26;
  const clientUser = useClientUser();

  return (
    <SideNav>
      <SideNavLink
        icon={
          <TaskOutlinedIcon style={{ width: iconSize, height: iconSize }} />
        }
        to="/"
      >
        {t('orders.title')}
      </SideNavLink>
      <SideNavLink
        icon={<SavedSearchIcon style={{ width: iconSize, height: iconSize }} />}
        to={Navigation.permitSearch}
      >
        {t('permitSearch.navigationName')}
      </SideNavLink>
      <SideNavLink
        icon={<WorkOutlineIcon style={{ width: iconSize, height: iconSize }} />}
        to={
          clientUser.existsInManyCompanies
            ? ClientsNavigation.PATH
            : Navigation.clients.get.url(clientUser.firstClientId)
        }
      >
        {t('company')}
      </SideNavLink>
    </SideNav>
  );
};
